import React, { Component} from 'react';
import { IconButton } from "@m/alchemy-ui/IconButton";
import { ArrowRightIcon } from "@m/alchemy-ui/icons/ArrowRightIcon";
import * as COLORS from '../../../constants/colors';

export default class SidePane extends Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState(({ opened }) => (
      {
        opened: !opened,
      }
    ));
  }

  render() {
    const styles = {
      container: {
        position: 'fixed',
        left: this.state.opened ? '0' : '-370px',
        top: '0px',
        transition: 'left 0.7s cubic-bezier(0, 0.07, 0.36, 1.02)',
      },
      header: {
        backgroundColor: COLORS.PREVIEW_WHITE,
        width: '420px',
        height: '50px',
        padding: '5px 10px 5px 10px',
        borderTop: COLORS.BORDER_GRAY,
        borderRight: COLORS.BORDER_GRAY,
        borderBottom: COLORS.BORDER_GRAY,
        borderBottomRightRadius: '4px',
        fontSize: '20px',
        color: COLORS.PREVIEW_GRAY,
        lineHeight: '38px',
        fontWeight: '100',
        title: {
        }
      },
      content: {
        position: 'absolute',
        backgroundColor: '#fff',
        width: '370px',
        padding: '30px 25px 15px 25px',
        borderRight: COLORS.BORDER_GRAY,
        borderBottom: COLORS.BORDER_GRAY,
        borderBottomRightRadius: '5px',
        maxHeight: '590px',
        overflowY: 'auto',
   },
      button: {
        float: 'right',
        zIndex: '99999999',
        background: 'transparent',
        border: 'none',
        color: COLORS.PREVIEW_VERY_DARK_GRAY,
        cursor: 'pointer',
        transition: 'transform 0.7s ease-in-out',
        transformOrigin: '50% 50% 0px',
        transform: this.state.opened ? 'rotate(180deg)': 'rotate(0deg)',
        '-webkit-transform': this.state.opened ? 'rotate(180deg)': 'rotate(0deg)', /* Chrome, Safari, Opera */
        '-webkit-transform-origin': '50% 50% 0px', /* Chrome, Safari, Opera */
      }
    };

    return (
      <div style={styles.container} className="preview-container">
        <div style={styles.header}>
          <span style={styles.header.title}>
          Display Settings
          </span>
          <IconButton
            style={styles.button}
            icon={<ArrowRightIcon aria-hidden="true" size="32" />}
            onClick={this.handleClick.bind(this)}
          />
        </div>



        <div style={styles.content}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
